import { Menu, MenuProps } from '@mantine/core';

import classes from './StyledMenu.module.css';
import { ReactNode } from 'react';

type Props = MenuProps & {
  children?: ReactNode;
};

const StyledMenu = ({ children, ...props }: Props) => {
  return (
    <Menu
      classNames={{
        dropdown: classes.dropdown,
        itemLabel: classes.itemLabel,
        item: classes.item,
        label: classes.label,
      }}
      {...props}
    >
      {children}
    </Menu>
  );
};

export default StyledMenu;
